export default __webpack_public_path__ + "static/media/731_IMG2284.18c8fd44.jpg";